import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  DownloadSingleReportConfig,
  bulkInvoiceRowsData,
  orderSourceConfig,
  orderStatusConfig,
} from "../../types/types";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import {
  Alert,
  Button,
  FormControl,
  MenuItem,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import {
  createInvoice,
  generateBulkInvoice,
  getBulkConfirmStatus,
  getBulkOpertionData,
  getOrderListWithType,
  getUTCDate,
} from "../../services/manageOrderService";
import "./Bulk.css";
import "../viewOrder/ViewOrder.css";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import Header from "../../components/dms_common/Header";
import CustomDataGrid from "../../components/dms_common/CustomDataGrid";
import {
  getDownloadSingleReportConfig,
  getOrderSource,
  bulkInvoiceColumnsMetaData,
} from "./ManageSecondaryOrderUtils";
import {
  filterData,
  getMultipleFilterBasedData,
  searchWithStatusFilter,
  updateDatesInLocalStorage,
} from "../../components/dms_common/DmsCommonServices";
import {
  isGapMoreThanNDays,
  isStartDateIsGreaterThanEndDate,
} from "../../utils/calenderUtils";
import { getConfigData } from "../../services/configurationService";
import JSZip from 'jszip';

import {
  createAndDownloadInvoicePdf,
  GenericModal,
  getGenericModalProps,
  printBulkInvoicePdfCokeNp,
  initialGenericModalProps,
  getBatchCodes,
  createSkuWiseStockMap,
} from "../viewOrder/ViewOrderUtils";

import {
  BulkStatus,
  determineBulkStatus,
  initialBulkStatusMap,
  showProgressInitialState,
} from "./BulkUtils";
import BulkProgress from "./BulkProgress";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import { getAccessToken } from "../../services/authenticationService";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import { analytics, logLoadTrace, performance } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { trace, PerformanceTrace } from "firebase/performance";
import useSessionStorageDates from "../../components/dms_common/UseSessionStorageDates";
import { BulkOrderMapType, orderStatusMap } from "./BulkConfirm";
import { fetchBatchWiseStock, setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";
import { getQuantityType, truncateString } from "../../components/dms_common/DmsUtils";
import { getDataFromLocalDb } from "../../services/dbService";
import { CustomBulkModal } from "../../components/dms_common/CustomBulkModal";
import { useNavigate } from "react-router-dom";
import FormHeader from "../../components/dms_common/FormHeader";
import Search from "../../components/dms_common/Search";
import { capitalizeFirstLetter } from "../../utils/utils";
import { useLocation } from "react-router-dom";

type OrderNumberBatchCodesMapType = {
  [key: string]: string
}

const BulkInvoice = () => {


  const location = useLocation();
  const { selectedPendingOrder = [] } = location.state || {};
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const startDateAtLastNDays = ConfigDictionary?.startDateAtLastNDays ?? 0
  const multipleCategoryFilterEnabled = ConfigDictionary?.multipleCategoryFilterEnabled ?? false
  const newStartDate = dayjs().subtract(startDateAtLastNDays, 'day')

  const { storedStartDate, storedEndDate, storeSessionStorageDates } = useSessionStorageDates("bulkInvoice",newStartDate)

  const [data, setData] = useState<bulkInvoiceRowsData[]>([]);
  const [rows, setRows] = useState<bulkInvoiceRowsData[]>([]);
  const [orderTrackingStagesList, setOrderTrackingStagesList] = useState<
    orderStatusConfig[]
  >([]);
  const [startDate, setStartDate] = useState<Dayjs>(storedStartDate);
  const [endDate, setEndDate] = useState<Dayjs>(storedEndDate);
  const [loader, setLoader] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const allOrdersReportIdRef = useRef<string | null>(null);
  const singleOrderReportIdRef = useRef<string | null>(null);
  const orderSourcesRef = useRef<Record<string, orderSourceConfig>>({});
  const fetchLimitedOrderData = useRef<boolean>(false);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
    useState<DownloadSingleReportConfig | null>();
  const [checkedOrderNumbers, setCheckedOrderNumbers] = useState<string[]>([...selectedPendingOrder]);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const [isBulkStillProcessing, setIsBulkStillProcessing] = useState<boolean>(true);
  const [bulkId, setBulkId] = useState<string | undefined>(undefined);
  const [orderBulkStatusMap, setOrderBulkStatusMap] = useState<BulkOrderMapType>(orderStatusMap);
  const routeIdNameMappingRef = useRef<any>({});
  const skuReplacementMappingRef = useRef<any>({});
  const [skuReplacementConfigValue, setSkuReplacementConfigValue] = useState<string>("");
  const [summaryInvoicableCount, setSummaryInvoicableCount] = useState<number>(0);
  const [summaryPartiallyInvoicableCount, setSummaryPartiallyInvoicableCount] = useState<number>(0);
  const [summaryUnavailableCount, setSummaryUnavailableCount] = useState<number>(0);
  const productDataRef = useRef<any>({})
  const [bulkInvoiceButtonLoading,setBulkInvoiceButtonLoading] = useState<boolean>(false)

  const [bulkInvoiceStatusMap, setBulkInvoiceStatusMap] =
    useState<BulkStatus>(initialBulkStatusMap);
  const [showProgress, setShowProgress] = useState<any>(
    showProgressInitialState
  );
  const [nonSelectableOrderNumbers, setNonSelectableOrderNumbers] = useState<
    string[]
  >([]);
  const [invoiceNumbers, setInvoiceNumbers] = useState<string []>([])
  const [printInvoicesLoading, setPrintInvoicesLoading] = useState<boolean>(false)
  const [resetSearch, setResetSearch] = useState(false);
  const [isInvoicingStarted, setIstInvoicingStarted] = useState(false);
  const orderConfirmationEnabled = useRef<boolean>(true);

  const disableStockCheck = useRef<boolean>(false);
  const [invoicableOrders, setInvoicableOrders] = useState<bulkInvoiceRowsData[]>([]);
  const [partiallyInvoicableOrders, setPartiallyInvoicableOrders] = useState<bulkInvoiceRowsData[]>([]);
  const [unavailableOrders, setUnavailableOrders] = useState<bulkInvoiceRowsData[]>([]);

  const [multipleFiltersVisible, setMultipleFiltersVisible] =
    useState<boolean>(false);
  const [statusFilter, setStatusFilter] = useState<string>("ALL");
    
  const [filterSearchValue, setFilterSearchValue] = useState<string>("");
  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => {
    const stored = localStorage.getItem('multipleFiltersListBulkInvoice');
    return stored ? JSON.parse(stored) : {};
  });
  const [selectedFilterType, setSelectedFilterType] = useState("salesRepName");
  const [multipleFiltersList, setMultipleFiltersList] = useState<
    Record<string, Record<string, number>>
  >({});
  const [filterKeys, setFilterKeys] = useState<string[]>([]); 

  const feature = "Sale";
  const pageID = "ManageOrder";
  const bulkType = "invoice";
  const ACCESS_TOKEN = getAccessToken() ?? "";
  const outletListRef = useRef<any>({});


  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  function canWeMakeRequest() {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, validDateRange)) {
      setGenericModalProps(
        getGenericModalProps("positive", `You can't select date range more than ${validDateRange} days!`)
      );
      return false;
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      setGenericModalProps(
        getGenericModalProps("positive", "To Date should be greater than from date.")
      );
      return false;
    }
    updateDatesInLocalStorage(startDate, endDate, feature, pageID);
    return true;
  }
  const resetGenericModalProps = () => setGenericModalProps(initialGenericModalProps);


  const handleApplyLog = async() => {
      logLoadTrace(handleApply,"bulk_invoice_page_load_time");
  }

  const handleApply = async () => {
    if (canWeMakeRequest()) {
      storeSessionStorageDates(startDate, endDate)
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllOrderData(start, end);
      setBulkId(undefined);
      setIsBulkStillProcessing(true);
      setOrderBulkStatusMap(orderStatusMap)
      setLoader(false);
    }
  };

  const handleClearAllLog = async() => {
      logLoadTrace(handleClearAll,"bulk_invoice_page_load_time");
  }

  const handleClearAll = async () => {
    const date = dayjs();
    storeSessionStorageDates(newStartDate, date)
    const start = getUTCDate(newStartDate, "start");
    const end = getUTCDate(date, "end");
    setStartDate(newStartDate);
    setEndDate(date);
    await getAllOrderData(start, end);
  };

  const getAllOrderData = async (startDate: string, endDate: string) => {
    reset()
    try {
      const routeIdNameMapping = routeIdNameMappingRef.current;
      const outletListResult = outletListRef.current;
      let pageNumber = 0;
      let hasMoreData = true;
      setLoader(true);
      let responseArray: bulkInvoiceRowsData[] = [];
      const statuses = orderConfirmationEnabled.current ?  "CONFIRMED,PARTIALLY CONFIRMED" :  "CONFIRMED,PARTIALLY CONFIRMED,PENDING"
      while (hasMoreData){
        const response = await getOrderListWithType(
          startDate,
          endDate,
          "secondary,VisitOrder,subd",
          statuses,
          true,
          true,
          pageNumber,
          (!(fetchLimitedOrderData.current) || (!orderConfirmationEnabled.current && !disableStockCheck.current))
        );
        if (response?.data?.features?.length > 0) {
          // hasMoreData = response?.data?.features?.length < 1000 ? false : true;
          response?.data?.features?.forEach((item: any, index: any) => {
            const {
              id,
              outletName,
              outletCode,
              creationTime,
              totalCaseQuantity,
              totalPieceQuantity,
              totalOtherUnitQuantity,
              netAmount,
              status,
              orderNumber,
              salesRepName,
              salesRepId,
              orderDetails = {},
              invoiceNumber,
            } = item || {};

              const extraParams = status === "INVOICED" ? `?type=invoice` : ``;
              const orderSource = getOrderSource(item);
              const gstNo = outletListResult?.[outletCode]?.[0]?.gstNo ? "GST Outlet" : "Non-GST Outlet"
              const outletHasGstin = outletListResult?.[outletCode]?.[0]?.gstNo ? true : false
              const routeId = item?.beat ?? ""
              const routeName = (ConfigDictionary.fetchPricingBySalesrep) ? (routeIdNameMapping?.[routeId]?.filter1 ?? "-") : (item?.beatName ?? "-");
              const routeIdAndName = routeId ? (routeIdNameMapping?.[routeId]?.filter1 ? `${routeId}-${routeIdNameMapping[routeId].filter1}` : routeId) : "";
              responseArray.push({
                id: orderNumber,
                orderId: id,
                outletName,
                outletCode,
                creationTime,
                totalCaseQuantity,
                totalPieceQuantity,
                totalOtherUnitQuantity,
                netAmount: netAmount,
                status: status
                  .toLowerCase()
                  .replace(/(?:^|\s|&)\S/g, (match: any) => match?.toUpperCase()),
                orderNumber,
                source: orderSource,
                extraParams,
                salesRepName,
                salesRepId,
                orderDetails,
                refNo:("Order: " + orderNumber),
                invoiceNumber: invoiceNumber ?? "",
                gstNo,
                outletHasGstin,
                routeId,
                routeName,
                routeIdAndName,
              });
            });
          } else {
          hasMoreData = false;
          // setRows([]);
          // setData([]);
        }
        pageNumber += 1; 
      }

      setRows(responseArray);
      setData(responseArray);
      setSearchedValue("");
    } catch (error) {
      setRows([]);
      setGenericModalProps(
        getGenericModalProps("error", "Something went wrong")
      );
    } finally {
      setLoader(false);
    }
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };


  const filteredData = useMemo(() => {
    const labelToIdMap = new Map<string, string>();

    orderTrackingStagesList.forEach((stage) => {
      if (stage?.dmsLabel && stage?.id) {
        labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
      }
    });

    // If user has manually changed filters and we have selectedFilters, use those
    // Otherwise fall back to statusFilter for backward compatibility
    const hasUserSelectedFilters = Object.keys(selectedFilters).length > 0 &&
      Object.values(selectedFilters).some(arr => arr.length > 0);

    let finalFilteredData = data;

    if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
      // Use multiple filter approach when user has selected specific filters
      const updatedSelectedFilters = { ...selectedFilters };

      // Convert status labels to IDs if needed
      if (filterKeys.includes("status") && selectedFilters["status"]) {
        let statuses: string[] = [];
        selectedFilters["status"].forEach((status) => {
          statuses = [...statuses, ...labelToIdMap.get(status.toUpperCase())?.split(',').map((label) => label.trim()) ?? []];
        });
        updatedSelectedFilters["status"] = statuses;
      }

      finalFilteredData = getMultipleFilterBasedData(data, updatedSelectedFilters, filterKeys);
    } else {
      // Fall back to original statusFilter approach for backward compatibility
      finalFilteredData = data;
    }

    // Apply search filtering
    const searchFilteredData = filterData(
      finalFilteredData,
      searchedValue?.toLowerCase(),
      searchWithStatusFilter,
      hasUserSelectedFilters ? "ALL" : statusFilter
    );

    let filteredResults = searchFilteredData;

    if (multipleCategoryFilterEnabled && hasUserSelectedFilters) {
      // Find intersection for multiple filters
      filteredResults = finalFilteredData.filter((item: any) =>
        new Set(searchFilteredData).has(item)
      );
    }

    if (searchedValue?.length !== 0) {
      logEvent(analytics, "search_bulk_invoice", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "search_query": searchedValue,
        "result_count": filteredResults?.length ?? 0,
      });
    }

    if (hasUserSelectedFilters) {
      logEvent(analytics, "search_bulk_invoice", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "filter_type": "multiple_filters_applied",
      });
    } else if (statusFilter !== "ALL") {
      logEvent(analytics, "search_bulk_invoice", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "filter_type": statusFilter,
      });
    }

    return filteredResults;
  }, [
    searchedValue,
    statusFilter,
    data,
    selectedFilters,
    filterKeys,
  ]);

  const handleSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getInitalTableData = async () => {
    const start = getUTCDate(startDate, "start");
    const end = getUTCDate(endDate, "end");
    await getAllOrderData(start, end);
  };


  const fetchRequiredConfigs = async () => {
    try {
      const orderTrackingStages = await getConfigData(
        "order_configuration",
        "orderTrackingStages"
      );
      const allOrdersReportId = await getConfigData(
        "dms_configuration",
        "orderReportId"
      );
      const fetchLimitedOrderDataConfig = await getConfigData(
        "dms_configuration",
        "fetchLimitedOrderData"
      );
      const res = await getConfigData(
        "order_configuration",
        "orderConfirmationEnabled"
      )
      const dbResult = await getDataFromLocalDb("RouteNameIdMapping");
      routeIdNameMappingRef.current = dbResult?.data?.[0]?.data ?? {};

      const skuReplacementData = await getDataFromLocalDb("SkuReplacementData")
      skuReplacementMappingRef.current = skuReplacementData?.data?.[0]?.data ?? {};

      const productResult = await getDataFromLocalDb("Product");
      productDataRef.current = productResult?.data?.[0]?.data ?? {};

      const skuReplacementConfig = await getConfigData("dms_configuration", "enableSKUReplacement");
      setSkuReplacementConfigValue(skuReplacementConfig[0]?.configValue ?? "")


      const filterKeysConfig = await getConfigData("dms_configuration","multiFilterKeysBulkInvoice");
      setFilterKeys(filterKeysConfig[0]?.configValue ?? ["status", "salesRepName"]);
      const res2 = await getConfigData("dms_configuration", "disableStockCheck");
      const orderSourcesConfig = await getConfigData("dms_configuration", "orderSources");
      const secondaryOrderReportId = allOrdersReportId[0]?.configValue ?? "";
      fetchLimitedOrderData.current = fetchLimitedOrderDataConfig?.[0]?.configValue ?? false;
      allOrdersReportIdRef.current = secondaryOrderReportId;
      singleOrderReportIdRef.current = secondaryOrderReportId;
      const orderSourcesMapping: Record<string, orderSourceConfig> = {};
      orderSourcesConfig[0]?.configValue?.forEach((sourceObj: orderSourceConfig) => {
        orderSourcesMapping[sourceObj.id] = sourceObj;
      });
      orderSourcesRef.current = orderSourcesMapping;
      orderConfirmationEnabled.current = res[0]?.configValue ?? true
      disableStockCheck.current = res2[0]?.configValue?.toLowerCase?.() === "true" ? true : false;
      setOrderTrackingStagesList(orderTrackingStages[0]?.configValue ?? []);
      setDownloadSingleReportConfig(
        getDownloadSingleReportConfig(secondaryOrderReportId)
      );
    } catch (e) {
      console.error("Error while fetching configs", e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching configs")
      );
    }
  };

  const fetchOutletGstData = async () => {
    const outletListResult = await getDataFromLocalDb("OutletList");
    const groupedByOutletCode = (outletListResult?.data ?? []).reduce(
      (acc: Record<string, any[]>, item: any) => {
        const code = item?.outletCode;
        if (!acc[code]) {
          acc[code] = [];
        }
        acc[code].push(item);
        return acc;
      },
      {}
    );
    outletListRef.current = groupedByOutletCode;
  }

  const init = async () => {
    setLoader(true);
    await fetchRequiredConfigs()
    await fetchOutletGstData();
    await getInitalTableData()
  };

  useEffect(() => {
    logLoadTrace(init,"bulk_invoice_page_load_time");
  }, []);

  useEffect(() => {
    if (!orderConfirmationEnabled.current && !disableStockCheck.current) fetchStockData()
  }, [checkedOrderNumbers]);

  const filterOrders = (rowsData: bulkInvoiceRowsData[]): void => {
    setRows(rowsData);
    reset();
  };

  const handleSetCheckedIdArray = (ids: any[]) => {
    const updatedIds = [...ids]?.filter(
      (id: string) => !nonSelectableOrderNumbers?.includes(id)
    );
    setCheckedOrderNumbers(updatedIds);
  };

  const handleBulkInvoicingNewApproach = async () => {
    try {
      let selectedOrders: bulkInvoiceRowsData[] = [];
      for (const ro of data) {
        const orderNumber = ro.orderNumber;
        // NOTE: only use selected rows
        if (!checkedOrderNumbers.includes(orderNumber)) continue;
        selectedOrders.push(ro);
      }
      let confirmableOrderNumbers: string[] = (selectedOrders)?.flatMap(s => s?.orderNumber) ?? [];

      const res = await generateBulkInvoice(confirmableOrderNumbers);
      const newOrderStatusMap: BulkOrderMapType = {
        inProgress: [],
        confirmed: [],
        partiallyConfirmed: [],
        rejected: [],
        failed: [],
        invoiced: [],
        partiallyInvoiced: [],
      };
      newOrderStatusMap.inProgress.push(...confirmableOrderNumbers);

      if (res.status === 208) {
        setOrderBulkStatusMap(orderStatusMap);
        setBulkId(undefined);
        setIsBulkStillProcessing(true);
      } else if(res && res?.data?.bulkId){
        setOrderBulkStatusMap(newOrderStatusMap);
        let bulkId = res?.data?.bulkId;
        setBulkId(bulkId);
        setIsBulkStillProcessing(true);
      }
    } catch (error) {
      console.error("Error during bulk invoicing: ", error);
      setGenericModalProps(
        getGenericModalProps("error", "An error occurred while processing bulk invoicing. Please try again.")
      );
    } 
  };

  const handleUpdateBulkStatus = async (bulkId: string | undefined) => {
    const { newOrderStatusMap, orderInvoiceNumberMap } = await getBulkOpertionData(bulkId);
    console.log("newOrderStatusMap", newOrderStatusMap)
    let isStillInProgress = newOrderStatusMap?.inProgress?.length > 0;
    let confirmed: string[] = newOrderStatusMap?.confirmed || [];
    let partialConfirmed: string[] = newOrderStatusMap?.partiallyConfirmed || [];
    let rejected: string[] = newOrderStatusMap?.rejected || [];
    let invoice: string[] = newOrderStatusMap?.invoiced || [];
    let partiallyInvoiced: string[] = newOrderStatusMap?.partiallyInvoiced || [];
    let failed: string[] = newOrderStatusMap?.failed || [];

    let dataOrderNumbers: string[] = [];
    for (const ro of data) {
      let roON = ro?.orderNumber;
      dataOrderNumbers.push(roON);
    }

    // Filter each status array to only include order numbers present in dataOrderNumbers
    newOrderStatusMap.inProgress = (newOrderStatusMap?.inProgress || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.confirmed = (newOrderStatusMap?.confirmed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.partiallyConfirmed = (newOrderStatusMap?.partiallyConfirmed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.rejected = (newOrderStatusMap?.rejected || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.invoiced = (newOrderStatusMap?.invoiced || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.partiallyInvoiced = (newOrderStatusMap?.partiallyInvoiced || []).filter(orderNum => dataOrderNumbers.includes(orderNum));
    newOrderStatusMap.failed = (newOrderStatusMap?.failed || []).filter(orderNum => dataOrderNumbers.includes(orderNum));

    const excluded = new Set([
      ...confirmed,
      ...partialConfirmed,
      ...rejected,
      ...invoice,
      ...partiallyInvoiced,
      ]);

    // Filter `pre` to remove excluded items
    const filtered = checkedOrderNumbers.filter(orderNumber => !excluded.has(orderNumber));

    // Set the new state
    setCheckedOrderNumbers(filtered);
    setOrderBulkStatusMap(newOrderStatusMap);
    setIsBulkStillProcessing(isStillInProgress);
    setInvoiceNumbers([...invoiceNumbers, ...Object.values(orderInvoiceNumberMap)])

    if(isBulkStillProcessing && !isStillInProgress) {
      setTimeout(() => {
        setShowProgress(showProgressInitialState);
      }, 5000);
    }
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      if(isBulkStillProcessing && (useKafkaBulkFlow && useKafkaBulkFlow)) {
        handleUpdateBulkStatus(bulkId);
      }
    }, 1000);

    // Cleanup to avoid memory leaks
    return () => clearInterval(intervalId);
  }, [isBulkStillProcessing, bulkId]);

  const getBatchCodeQuantities = (batchCodes: string, batchCodeMap: any): Map<string, [number, number, number]> => {
    let batchCodesArray: string[] = batchCodes ? batchCodes.split(",") : [];
    const result = new Map<string, [number, number, number]>();
    
    batchCodesArray.forEach((bc) => {
        const skuStock = batchCodeMap?.[bc];
        if (!skuStock) {
            // If the batch code doesn't exist in the map, set all quantities to 0
            result.set(bc, [0, 0, 0]);
            return;
        }
        
        let {
            availableCaseQty = 0,
            availablePieceQty = 0,
            availableOtherQty = 0,
            committedCaseQty = 0,
            committedPieceQty = 0,
            committedOtherQty = 0,
        } = skuStock;
        
        let availableStock = {
            cs: availableCaseQty,
            pc: availablePieceQty,
            other: availableOtherQty,
            csComitted: committedCaseQty,
            pcComitted: committedPieceQty,
            otherComitted: committedOtherQty,
        };
        
        // Store the quantities for this batch code in the map
        result.set(bc, [availableStock.cs, availableStock.pc, availableStock.other]);
    });
    
    return result;
  };

  const fetchStockData = async () => {
    if (checkedOrderNumbers?.length < 1) return;
    // Start a custom trace for view secondary order page load time
    const pageLoadTrace: PerformanceTrace = trace(
      performance,
      "manage_secondary_order_bulk_confirm_page_stock_load_time"
    );
    pageLoadTrace.start();
    let allBatchCodesSet: Set<string> = new Set(); // Use a Set to store unique batch codes
    let batchCodeMap: OrderNumberBatchCodesMapType = {};
    let selectedOrderData: bulkInvoiceRowsData[] = [];

    for (const ro of data) {
      const orderedBatchCodes: string =
        getBatchCodes(ro["orderDetails"] ?? "") ?? "";
      const orderNumber = ro.orderNumber;

      if (!checkedOrderNumbers.includes(orderNumber)) continue;
      selectedOrderData.push(ro);
      batchCodeMap[orderNumber] = orderedBatchCodes;

      // Split batch codes and add to the Set to ensure uniqueness
      const codesArray = orderedBatchCodes
        .split(",")
        .map((code) => code.trim())
        .filter(Boolean);
      codesArray.forEach((code) => allBatchCodesSet.add(code));
    }

    let allBatchCodes = Array.from(allBatchCodesSet).join(",");

    if (allBatchCodes?.length === 0) return;

    const BATCH_SIZE = 100;
    const allBatchCodesArray = allBatchCodes
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);

    let stocksData: any[] = [];

    for (let i = 0; i < allBatchCodesArray?.length; i += BATCH_SIZE) {
      const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE);
      const chunkString = chunk.join(",");

      const chunkStockData = await setRealTimeStockDataInDb(
        chunkString,
        getQuantityType()
      );
      stocksData = stocksData.concat(chunkStockData);
    }

    let stocksDataResult = await createSkuWiseStockMap(stocksData);
    let stockBatchWiseMap = getBatchCodeQuantities(
      allBatchCodes,
      stocksDataResult
    );

    const ConfigDictionary = JSON.parse(
      localStorage.getItem("ConfigDictionary") ?? "{}"
    );
    const { uomConversion } = ConfigDictionary;
    const dbResult = await getDataFromLocalDb("Product");
    const products: any = dbResult?.data?.[0]?.data ?? {};
    let confOrders: bulkInvoiceRowsData[] = [];
    let parOrders: bulkInvoiceRowsData[] = [];
    let canOrders: bulkInvoiceRowsData[] = [];

    // First, let's calculate normalized quantities for the stockBatchWiseMap
    const normalizedStockMap = new Map<string, number>();

    // Preprocess the stock data to include normalized quantities
    if (uomConversion) {
      // Convert Map entries to array for compatibility with older ES versions
      const stockBatchWiseEntries: Array<[string, [number, number, number]]> =
        [];
      stockBatchWiseMap.forEach((value, key) => {
        stockBatchWiseEntries.push([key, value]);
      });

      for (let i = 0; i < stockBatchWiseEntries.length; i++) {
        const [batchCode, quantities] = stockBatchWiseEntries[i];
        const product = products[batchCode];
        if (product) {
          const [avCs, avPi, avOth] = quantities;
          // Calculate normalized quantity based on product conversion factors
          const stockNormalizedQty =
            avCs * (product?.caseToPieceQuantity ?? 0) +
            avOth * (product?.otherUnitToPieceQuantity ?? 0) +
            avPi;

          // Store the normalized quantity for this batch code
          normalizedStockMap.set(batchCode, stockNormalizedQty);
        }
      }
    }

    // Process each order
    for (const ro of selectedOrderData.sort(
      (a, b) =>
        new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
    )) {
      let canFulfillCompletely = true;
      let canFulfillPartially = false;
      let hasAnyUnfulfillableItems = false;
      let unFulFillableItems: number = 0;

      // Deep clone the stockBatchWiseMap
      const tempStockMap = new Map<string, [number, number, number]>();
      stockBatchWiseMap.forEach((value, key) => {
        tempStockMap.set(key, [...value]);
      });

      // Clone the normalizedStockMap
      const tempNormalizedStockMap = new Map<string, number>();
      normalizedStockMap.forEach((value, key) => {
        tempNormalizedStockMap.set(key, value);
      });

      // Check availability for all items in this order
      for (const roo of ro["orderDetails"]) {
        let caseOQ = roo?.caseQuantity ?? 0;
        let pieceOQ = roo?.pieceQuantity ?? 0;
        let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
        let batchCode = roo?.batchCode ?? "";

        let product = products[batchCode];

        if (uomConversion && product) {
          // Get or calculate normalized order quantity
          let orderDetailsNQ =
            roo?.normalizedQuantity ??
            caseOQ * (product?.caseToPieceQuantity ?? 0) +
              otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
              pieceOQ;

          // Get normalized stock quantity
          let stockNQ = tempNormalizedStockMap.get(batchCode) ?? 0;

          if (stockNQ === 0) {
            canFulfillCompletely = false;

            // If we need items from this batch and there's no stock for this item
            if (orderDetailsNQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (stockNQ >= orderDetailsNQ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (orderDetailsNQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            // We can only partially fulfill this item
            canFulfillCompletely = false;

            // If there's any stock available and we need this item, we can partially fulfill
            if (orderDetailsNQ > 0 && stockNQ > 0) {
              canFulfillPartially = true;
            }
          }
        } else {
          // Original non-conversion logic
          let [avCs, avPi, avOth] = tempStockMap.has(batchCode)
            ? tempStockMap.get(batchCode) ?? [0, 0, 0]
            : [0, 0, 0];

          // Check if there's no stock at all for this batch code
          if (avCs === 0 && avPi === 0 && avOth === 0) {
            canFulfillCompletely = false;

            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (
            avCs >= caseOQ &&
            avPi >= pieceOQ &&
            avOth >= otherUnitOQ
          ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            canFulfillCompletely = false;

            if (
              (caseOQ > 0 && avCs > 0) ||
              (pieceOQ > 0 && avPi > 0) ||
              (otherUnitOQ > 0 && avOth > 0)
            ) {
              canFulfillPartially = true;
            }
          }
        }
      }

      hasAnyUnfulfillableItems = !(
        unFulFillableItems === ro["orderDetails"]?.length
      );

      // Categorize the order based on our findings
      if (canFulfillCompletely) {
        // Handle complete fulfillment
        if (uomConversion) {
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            let product = products[batchCode];

            if (product && normalizedStockMap.has(batchCode)) {
              // Calculate normalized order quantity
              let orderDetailsNQ =
                roo?.normalizedQuantity ??
                caseOQ * (product?.caseToPieceQuantity ?? 0) +
                  otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
                  pieceOQ;

              // Deduct from normalized stock
              let currentNQ = normalizedStockMap.get(batchCode) ?? 0;
              normalizedStockMap.set(batchCode, currentNQ - orderDetailsNQ);

              // Also update the original stock map
              if (stockBatchWiseMap.has(batchCode)) {
                let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [
                  0, 0, 0,
                ];
                stockBatchWiseMap.set(batchCode, [
                  Math.max(0, avCs - caseOQ),
                  Math.max(0, avPi - pieceOQ),
                  Math.max(0, avOth - otherUnitOQ),
                ]);
              }
            }
          }
        } else {
          // Original non-conversion logic for complete fulfillment
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";

            if (stockBatchWiseMap.has(batchCode)) {
              let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [
                0, 0, 0,
              ];
              stockBatchWiseMap.set(batchCode, [
                avCs - caseOQ,
                avPi - pieceOQ,
                avOth - otherUnitOQ,
              ]);
            }
          }
        }
        confOrders.push(ro);
      } else if (
        canFulfillPartially ||
        (!canFulfillPartially && hasAnyUnfulfillableItems)
      ) {
        // Handle partial fulfillment - even if some items have zero stock
        if (uomConversion) {
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            let product = products[batchCode];

            if (product && normalizedStockMap.has(batchCode)) {
              // Calculate normalized order quantity
              let orderDetailsNQ =
                roo?.normalizedQuantity ??
                caseOQ * (product?.caseToPieceQuantity ?? 0) +
                  otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
                  pieceOQ;

              // Get available normalized stock
              let availableNQ = normalizedStockMap.get(batchCode) ?? 0;

              // Determine how much we can fulfill
              let fulfillableNQ = Math.min(availableNQ, orderDetailsNQ);

              if (fulfillableNQ > 0) {
                // Deduct from normalized stock
                normalizedStockMap.set(batchCode, availableNQ - fulfillableNQ);

                // Determine how to distribute the fulfillment across units
                if (stockBatchWiseMap.has(batchCode)) {
                  let [avCs, avPi, avOth] = stockBatchWiseMap.get(
                    batchCode
                  ) ?? [0, 0, 0];

                  // Deduct only what we can fulfill for each unit type
                  let deductCs = Math.min(avCs, caseOQ);
                  let deductPi = Math.min(avPi, pieceOQ);
                  let deductOth = Math.min(avOth, otherUnitOQ);

                  stockBatchWiseMap.set(batchCode, [
                    avCs - deductCs,
                    avPi - deductPi,
                    avOth - deductOth,
                  ]);
                }
              }
            }
          }
        } else {
          // Original non-conversion logic for partial fulfillment
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";

            if (stockBatchWiseMap.has(batchCode)) {
              let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [
                0, 0, 0,
              ];

              let deductCs = Math.min(avCs, caseOQ);
              let deductPi = Math.min(avPi, pieceOQ);
              let deductOth = Math.min(avOth, otherUnitOQ);

              stockBatchWiseMap.set(batchCode, [
                avCs - deductCs,
                avPi - deductPi,
                avOth - deductOth,
              ]);
            }
          }
        }
        parOrders.push(ro);
      } else {
        // Cannot fulfill at all
        canOrders.push(ro);
      }
    }
    setInvoicableOrders(confOrders);
    setPartiallyInvoicableOrders(parOrders);
    setUnavailableOrders(canOrders);
    pageLoadTrace.stop();
  };

  useEffect(() => {
    const updateProgressbar = () => {
      let pending: string[] = [];
      let rejected: string[] = [];
      let failed: string[] = [];
      let confirmed: string[] = [];
      let partiallyConfirmed: string[] = [];
      let invoiced: string[] = [];
      let partiallyInvoiced: string[] = [];

      for (const ro of data) {
        let orderNumber: string = ro?.orderNumber;
        if (orderBulkStatusMap.inProgress.includes(orderNumber)) {
          pending.push(orderNumber);
        } else if (orderBulkStatusMap.rejected.includes(orderNumber)) {
          rejected.push(orderNumber);
        } else if (orderBulkStatusMap.failed.includes(orderNumber)) {
          failed.push(orderNumber);
        } else if (orderBulkStatusMap.confirmed.includes(orderNumber)) {
          confirmed.push(orderNumber);
        } else if(orderBulkStatusMap.invoiced.includes(orderNumber)){
          invoiced.push(orderNumber)
        } else if (orderBulkStatusMap.partiallyConfirmed.includes(orderNumber)) {
          partiallyConfirmed.push(orderNumber);
        } else if ((orderBulkStatusMap?.partiallyInvoiced ?? []).includes(orderNumber)) {
          partiallyInvoiced.push(orderNumber);
        }
      }
      if(pending.length + rejected.length + failed.length + confirmed.length + partiallyConfirmed.length + invoiced.length + partiallyInvoiced.length > 0) {
        setNonSelectableOrderNumbers([...invoiced, ...partiallyInvoiced])
        setBulkInvoiceStatusMap((prev: BulkStatus) => ({
          ...prev,
          pending: [...pending],
          invoiced: [...prev.invoiced, ...invoiced],
          partiallyInvoiced: [...(prev?.partiallyInvoiced ?? []), ...partiallyInvoiced],
          rejected: [...prev.rejected, ...rejected],
          fail: [...prev.fail, ...failed],
        }));
      }
    }
    updateProgressbar();
  }, [orderBulkStatusMap])

  
  function deductStockFromOrders(
    stockMap: Map<string, { latestExpiryDate: string; totalNq: number }>,
    checkedOrderDetailsMap: Map<string, { batchCode: string; nq: number }[]>
  ) {
    checkedOrderDetailsMap.forEach((skuList, orderNumber) => {
      const updatedSkuList = skuList.map((sku) => {
        const stockEntry = stockMap.get(sku.batchCode);
  
        if (!stockEntry) return sku; // no stock entry, leave as is
  
        const availableStock = stockEntry.totalNq;
  
        // Deduct without going negative
        const deductedQty = Math.min(availableStock, sku.nq);
        stockEntry.totalNq = Math.max(availableStock - deductedQty, 0);
  
        return {
          ...sku,
          nq: Math.max(sku.nq - deductedQty, 0),
        };
      });
  
      // Update map with remaining SKUs
      checkedOrderDetailsMap.set(orderNumber, updatedSkuList);
    });
  }
  
  
  

  const createSkuBatchMap = (
    batchNodes: any[],
    productData: Record<string, any>
  ) => {
    const finalSkuBatchMap = new Map<
      string,
      { latestExpiryDate: string; totalNq: number }
    >();
  
    batchNodes.forEach((node: any) => {
      const productInfo = productData[node?.skuCode] ?? {};
      const caseToPiece = productInfo?.caseToPieceQuantity ?? 0;
      const otherUnitToPiece = productInfo?.otherUnitToPieceQuantity ?? 0;
  
      let nq = 0;
      switch (node.quantityType) {
        case "caseQty":
          nq = Number(node.availableQty ?? 0) * caseToPiece;
          break;
        case "otherQty":
          nq = Number(node.availableQty ?? 0) * otherUnitToPiece;
          break;
        case "pieceQty":
          nq = Number(node.availableQty ?? 0);
          break;
        default:
          nq = 0;
      }
  
      const existing = finalSkuBatchMap.get(node.skuCode);
      if (existing) {
        // sum up nq
        existing.totalNq += nq;
  
        // keep the latest (maximum) expiry date
        if (new Date(node.expiryDate).getTime() > new Date(existing.latestExpiryDate).getTime()) {
          existing.latestExpiryDate = node.expiryDate;
        }
      } else {
        finalSkuBatchMap.set(node.skuCode, {
          latestExpiryDate: node.expiryDate,
          totalNq: nq,
        });
      }
    });
  
    return finalSkuBatchMap;
  };
  
  
  function createStockMap(skuBatchMap: Map<string, any[]>): Map<string, number> {
    const stockMap = new Map<string, number>();
  
    skuBatchMap.forEach((batchList, batchCode) => {
      // batchList is an array of objects with nq property
      const totalNq = batchList.reduce((sum, batch) => sum + (batch.nq ?? 0), 0);
      stockMap.set(batchCode, totalNq);
    });
  
    return stockMap;
  }



  function countAndRemoveFullyInvoicedOrders(
    checkedOrderDetailsMap: Map<string, { batchCode: string; nq: number }[]>
  ): number {
    let count = 0;
  
    checkedOrderDetailsMap.forEach((skuList, orderNumber) => {
      const allFulfilled = skuList.every((sku) => sku.nq === 0);
      if (allFulfilled) {
        count++;
      }
    });
  
    return count;
  }

  function createReplacementMap(
    skuReplacementData: { entityId: string; parentId: string }[]
  ): Map<string, string[]> {
    const replacementMap = new Map<string, string[]>();
  
    skuReplacementData.forEach(({ entityId, parentId }) => {
      if (!replacementMap.has(entityId)) {
        replacementMap.set(entityId, []);
      }
  
      const arr = replacementMap.get(entityId)!;
  
      if (!arr.includes(parentId)) {
        arr.push(parentId);
      }
    });
  
    return replacementMap;
  }

  function calculateOrderInvoiceStatus(
    checkedOrderDetailsMap: Map<string, { batchCode: string; nq: number }[]>,
    originalCheckedOrderDetailsMap: Map<string, { batchCode: string; nq: number }[]>
  ) {
    let fullyInvoiced: string[] = [];
    let partialInvoiced: string[] = [];
    let failed: string[] = [];
  
    checkedOrderDetailsMap.forEach(
      (updatedSkuList: { batchCode: string; nq: number }[], orderNumber: string) => {
        const originalSkuList = originalCheckedOrderDetailsMap.get(orderNumber);
        if (!originalSkuList) return;
  
        let allNqZero = true;
        let allNqSame = true;
  
        updatedSkuList.forEach((updatedSku: { batchCode: string; nq: number }, index: number) => {
          const originalSku = originalSkuList[index];
          if (!originalSku) return;
  
          if (updatedSku.nq !== 0) {
            allNqZero = false;
          }
  
          if (updatedSku.nq !== originalSku.nq) {
            allNqSame = false;
          }
        });
  
        if (allNqSame) {
          failed = [...failed, orderNumber];
        } else if (allNqZero) {
          fullyInvoiced = [...fullyInvoiced, orderNumber];
        } else {
          partialInvoiced = [...partialInvoiced, orderNumber];
        }
      }
    );
  
    return { fullyInvoiced, partialInvoiced, failed };
  }

  const fetchBulkInvoiceSummary = async () => {
    let fullyInvoiced: string[] = [];
    let partialInvoiced: string[] = [];
    let failed: string[] = [];
  
    try {
      setBulkInvoiceButtonLoading(true);
  
      // fetch batchwise stock data from API
      const batchWiseStock = await fetchBatchWiseStock();
      
      // fetch sku replacement data from local DB
      const skuReplacementData = skuReplacementMappingRef.current;
      
      // map SKU to its list of replacement skus A->[B,C,D]
      const replacementSkuMap = createReplacementMap(skuReplacementData);
  
      // order data
      const orderData = data;
      
      // product data
      const productData = productDataRef.current ?? {};
  
      // map of order and list of SKU having batchCode and nq
      const checkedOrderDetailsMap = new Map();
  
      checkedOrderNumbers.forEach((orderNumber) => {
        const orderD = orderData.find((order: any) => order?.orderNumber === orderNumber);
        if (!orderD) return;
  
        // Only keep batchCode and nq
        const reducedOrderDetails = orderD.orderDetails
          .filter((detail: any) => detail.type !== "free")
          .map((detail: any) => {
            const productInfo = productData[detail.batchCode] ?? {};
            const caseToPieceQuantity = productInfo?.caseToPieceQuantity ?? 0;
            const otherUnitToPieceQuantity = productInfo?.otherUnitToPieceQuantity ?? 0;
  
            const nq =
              (Number(detail.caseQuantity ?? 0) * caseToPieceQuantity) +
              (Number(detail.otherUnitQuantity ?? 0) * otherUnitToPieceQuantity) +
              Number(detail.pieceQuantity ?? 0);
  
            return { batchCode: detail.batchCode, nq };
          });
  
        checkedOrderDetailsMap.set(orderNumber, reducedOrderDetails);
      });
  
      const originalCheckedOrderDetailsMap = new Map(
        Array.from(checkedOrderDetailsMap.entries()).map(([orderNumber, skuList]: any) => [
          orderNumber,
          skuList.map((sku: any) => ({ ...sku })),
        ])
      );
  
      // final stock data: batch code mapped to latest expiry and totalNq
      const skuMapTotalNqLatestExpiry = createSkuBatchMap(batchWiseStock, productData);
  
      // deduct stock from checkedOrderDetailsMap based on available stock
      deductStockFromOrders(skuMapTotalNqLatestExpiry, checkedOrderDetailsMap);
  
        // SKU replacement is enabled
        checkedOrderDetailsMap.forEach((skuList, orderNumber) => {
          skuList.forEach((sku: any) => {
            if (sku.nq <= 0) return; // Already fulfilled
  
            // Deduct from original SKU
            const originalStock = skuMapTotalNqLatestExpiry.get(sku.batchCode);
            if (originalStock) {
              const deductQty = Math.min(sku.nq, originalStock.totalNq);
              sku.nq -= deductQty;
              originalStock.totalNq -= deductQty;
            }
  
            // Deduct from replacement SKUs if still remaining
            if (sku.nq > 0) {
              const replacements = replacementSkuMap.get(sku.batchCode) ?? [];
  
              replacements.sort((a, b) => {
                const stockA = skuMapTotalNqLatestExpiry.get(a)?.latestExpiryDate ?? '';
                const stockB = skuMapTotalNqLatestExpiry.get(b)?.latestExpiryDate ?? '';
                return new Date(stockB).getTime() - new Date(stockA).getTime();
              });
  
              replacements.forEach((replacementBatch) => {
                if (sku.nq <= 0) return;
                const replacementStock = skuMapTotalNqLatestExpiry.get(replacementBatch);
                if (!replacementStock || replacementStock.totalNq <= 0) return;
  
                const deductQty = Math.min(sku.nq, replacementStock.totalNq);
                sku.nq -= deductQty;
                replacementStock.totalNq -= deductQty;
              });
            }
          });
  
          // Update order map
          checkedOrderDetailsMap.set(orderNumber, skuList);
        });
  
        // Recalculate invoice status after using replacements
        ({ fullyInvoiced, partialInvoiced, failed } = calculateOrderInvoiceStatus(
          checkedOrderDetailsMap,
          originalCheckedOrderDetailsMap
        ));
      
      return { fullyInvoiced, partialInvoiced, failed };
  
    } catch (err) {
      console.error("Error fetching bulk invoice summary:", err);
      return { fullyInvoiced: [], partialInvoiced: [], failed: [] };
    } finally {
      setBulkInvoiceButtonLoading(false);
    }
  };
  

  const handleBulkInvoiceClick = async () => {
    if (!checkedOrderNumbers || checkedOrderNumbers.length === 0) {
      setGenericModalProps(
        getGenericModalProps("positive", "Please select at least one order to create invoices.")
      );
      return;
    }
    if(orderConfirmationEnabled.current || disableStockCheck.current) {
      (useKafkaBulkFlow && useKafkaBulkFlow && checkedOrderNumbers?.length > 5) ? handleBulkInvoicingNewApproach() : handleBulkInvoicing()
      return;
    }

    if(skuReplacementConfigValue) {

      const bulkInvoiceSummaryResult = await fetchBulkInvoiceSummary();
      const { fullyInvoiced, partialInvoiced, failed } = bulkInvoiceSummaryResult;

      // Update the summary counts
      setSummaryInvoicableCount(fullyInvoiced?.length ?? 0);
      setSummaryPartiallyInvoicableCount(partialInvoiced?.length ?? 0);
      setSummaryUnavailableCount(failed?.length ?? 0);

      setInvoicableOrders(rows?.filter((s: bulkInvoiceRowsData) => fullyInvoiced?.includes(s?.orderNumber)));
      setPartiallyInvoicableOrders(rows?.filter((s: bulkInvoiceRowsData) => partialInvoiced?.includes(s?.orderNumber)));
      setUnavailableOrders(rows?.filter((s: bulkInvoiceRowsData) => failed?.includes(s?.orderNumber)));
    }
    
    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      "Review the Bulk Invoicing of the selected Orders:",
      "Continue",
      "Cancel",
      () => {
        (useKafkaBulkFlow && useKafkaBulkFlow && checkedOrderNumbers?.length > 5) ? handleBulkInvoicingNewApproach() : handleBulkInvoicing()
        resetGenericModalProps()
      },
      () => resetGenericModalProps(),
    );
    setGenericModalProps(updatedGenericModalProps);
  }

  const handleBulkInvoicing = async () => {
    try {

      if (!checkedOrderNumbers || checkedOrderNumbers.length === 0) {
        setGenericModalProps(
          getGenericModalProps("positive", "Please select at least one order to create invoices.")
        );
        return;
      }

      // Start a custom trace for manage secondary order bulk confirmation load time
      const pageLoadTrace: PerformanceTrace = trace(performance, "bulk_invoice_handle_invoicing_load_time");
      pageLoadTrace.start();

      setShowProgress({ progress: true, fail: true });

      setBulkInvoiceStatusMap({
        ...initialBulkStatusMap,
        pending: checkedOrderNumbers,
      });

      let total_orders_confirmed = 0;
      let total_orders_rejected = 0;
      
      // Process in batches of 30
      setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
        ...prev,
        inProgress: checkedOrderNumbers,
      }));
      const batchSize = 30;
      for (let i = 0; i < checkedOrderNumbers.length; i += batchSize) {
        const batch = checkedOrderNumbers.slice(i, i + batchSize);
        console.log(`Processing batch ${i/batchSize + 1}: ${batch.length} orders`);
        
        const batchResults = await Promise.allSettled(
          batch.map((orderNumber: string) =>
            (async () => {
              try {
                const discountPayload = {
                  orderNumber,
                  discountType: "value",
                  discountValue: 0,
                };
                const response = await createInvoice(discountPayload);
                if ((response?.status === 200 || response?.status === 201) && response?.data?.status === "INVOICED") {
                  setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                    ...prev,
                    invoiced: [...prev.invoiced, orderNumber],
                    inProgress: prev.inProgress.filter(order => order !== orderNumber),
                  }));
                  setRows((prevRows: bulkInvoiceRowsData[]) =>
                    prevRows.map((row: bulkInvoiceRowsData) => {
                      if (row.orderNumber === orderNumber) {
                        return {
                          ...row,
                          invoiceNumber: response?.data?.invoiceNumber || "",
                        };
                      }
                      return row;
                    })
                  );
                  setInvoiceNumbers((prev: string[]) => [...prev, response?.data?.invoiceNumber]);
                  setNonSelectableOrderNumbers((prev: string[]) => [...prev, orderNumber]);
                  return { success: true, orderNumber };
                } else if ((response?.status === 200 || response?.status === 201) && response?.data?.status === "REJECTED") {
                  setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                    ...prev,
                    rejected: [...prev.rejected, orderNumber],
                    inProgress: prev.inProgress.filter(order => order !== orderNumber),
                  }));
                  setNonSelectableOrderNumbers((prev: string[]) => [...prev, orderNumber]);
                  return { success: true, orderNumber };
                } else if (response?.data?.status === "PARTIALLY INVOICED") {
                  setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                    ...prev,
                    partiallyInvoiced: [...(prev?.partiallyInvoiced ?? []), orderNumber],
                    inProgress: prev.inProgress.filter(order => order !== orderNumber),
                  }));
                  setRows((prevRows: bulkInvoiceRowsData[]) =>
                    prevRows.map((row: bulkInvoiceRowsData) => {
                      if (row.orderNumber === orderNumber) {
                        return {
                          ...row,
                          invoiceNumber: response?.data?.invoiceNumber || "",
                        };
                      }
                      return row;
                    })
                  );
                  setInvoiceNumbers((prev: string[]) => [...prev, response?.data?.invoiceNumber || ""]);
                  setNonSelectableOrderNumbers((prev: string[]) => [...prev, orderNumber]);
                  return { success: true, orderNumber };
                }
                else {
                  throw new Error("Failed to create invoice");
                }
              } catch (error) {
                console.error(`Error processing order ${orderNumber}: `, error);
                setOrderBulkStatusMap((prev: BulkOrderMapType) => ({
                  ...prev,
                  failed: [...prev.failed, orderNumber],
                  inProgress: prev.inProgress.filter(order => order !== orderNumber),
                }));
                return { success: false, orderNumber };
              }  
            })()
          )
        );
        
        // Count successful and failed orders in this batch
        batchResults.forEach(result => {
          if (result.status === 'fulfilled') {
            const value = result.value;
            if (value.success) {
              total_orders_confirmed++;
            } else {
              total_orders_rejected++;
            }
          } else {
            total_orders_rejected++;
          }
        });
      }

      logEvent(analytics, "secondary_order_bulk_invoiced", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_orders_confirmed": total_orders_confirmed,
      });
      logEvent(analytics, "secondary_order_bulk_rejected", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_orders_rejected": total_orders_rejected,
      });

      // Once data is fetched and state is updated, stop the trace
      pageLoadTrace.stop();

    } catch (error) {
      console.error("Error during bulk invoicing: ", error);
      setGenericModalProps(
        getGenericModalProps("error", "An error occurred while processing bulk invoicing. Please try again.")
      );
    } finally {
      setCheckedOrderNumbers([]);
      setTimeout(() => {
        setShowProgress(showProgressInitialState);
      }, 5000);
    }
  };



  useEffect(() => {
    const { pass, partial, fail, pending, rejected, invoiced, partiallyInvoiced } = bulkInvoiceStatusMap;

    const updatedRows: bulkInvoiceRowsData[] = [...rows]?.map(
      (row: bulkInvoiceRowsData) => {
        const invoiceNumber = row?.invoiceNumber
        const orderNumber = row?.orderNumber;
        const status = determineBulkStatus(
          orderNumber,
          pass,
          partial,
          fail,
          pending,
          rejected,
          invoiced,
          row,
          partiallyInvoiced,
        );
        return { ...row, status, invoiceNumber };
      }
    );
    setRows(updatedRows);
    setData(updatedRows)
    const total: number =
      (bulkInvoiceStatusMap?.fail?.length ?? 0) +
      (bulkInvoiceStatusMap?.pass?.length ?? 0) +
      (bulkInvoiceStatusMap?.rejected?.length ?? 0) +
      (bulkInvoiceStatusMap?.invoiced?.length ?? 0) +
      (bulkInvoiceStatusMap?.pending?.length ?? 0) + (bulkInvoiceStatusMap?.partial?.length ?? 0) +
      (bulkInvoiceStatusMap?.partiallyInvoiced?.length ?? 0);
    if(total > 0) {
      setShowProgress({ progress: true, fail: true });
    }
  }, [bulkInvoiceStatusMap]);

  const handleHideProgress = (progressType: string) => {
    setShowProgress({ ...showProgress, [progressType]: false });
  };



  const reset = () => {
    setOrderBulkStatusMap(orderStatusMap);
    setLoader(false);
    setCheckedOrderNumbers([]);
    setBulkInvoiceStatusMap(initialBulkStatusMap);
    setShowProgress(showProgressInitialState);
    setNonSelectableOrderNumbers([]);
    setInvoiceNumbers([])
    setGenericModalProps(initialGenericModalProps)
    setPrintInvoicesLoading(false)
    setResetSearch(true); 
    setTimeout(() => setResetSearch(false), 0); 
  };
 


  const printBulkInvoices = async () => {
    setPrintInvoicesLoading(true)

    try {

      const invoiceReportConfig = await getConfigData("dms_configuration", "invoiceReportId");

      const blobKey = 
        invoiceReportConfig[0]?.configValue[0]?.taskName === "bulkInvoiceCokeNp"
          ? await printBulkInvoicePdfCokeNp(invoiceNumbers)
          : await createAndDownloadInvoicePdf(Array.from(invoiceNumbers), false, true);

      if (!blobKey?.[0] || !ACCESS_TOKEN) {
        console.error("Invalid URL or access token.");
        setGenericModalProps(getGenericModalProps("error", "Invalid URL or access token."));
        return;
      }

      const pdfUrl = `${blobKey?.[0]}?access_token=${ACCESS_TOKEN}`;
      window.open(pdfUrl, "_blank");
      logEvent(analytics, "secondary_invoice_report_downloaded", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id": invoiceNumbers,
        "download_format": "pdf",
      });      

    } catch(e:any) {
      logEvent(analytics, "secondary_invoice_download_failed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "invoice_id":invoiceNumbers,
        "error_reason": e.toString(),
      });
      console.error(e)
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching pdf url")
      );
    } finally {
      setPrintInvoicesLoading(false)
    }

  }

  const handleDownload = async (blobKeys: string [] = []) => {
    try {
      const zip = new JSZip();
      await Promise.all(
        blobKeys?.map(async (blobKey: string, index: number) => {

          if(!blobKey?.toLocaleLowerCase()?.includes(`fail`)) {
            const pdfUrl = `${blobKey}?access_token=${ACCESS_TOKEN}`
            const response = await fetch(pdfUrl);
            const blob = await response.blob();
            zip.file(`${invoiceNumbers?.[index]?.replace(/\//g, '-')}.pdf`, blob);
          }

        })
      );

      const content = await zip.generateAsync({ type: 'blob' });
      const url = URL.createObjectURL(content);

      const link = document.createElement('a');
      link.href = url;
      link.download = `Invoices_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.zip`;
      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(url); 
      
    } catch (error) {
      console.error("Error downloading PDFs", error);
      setGenericModalProps(
        getGenericModalProps("error","Error downloading PDFs")
      );
    } finally {
      setPrintInvoicesLoading(false)
    }
  };

  

  const bulkInvoceInProgress = Boolean(bulkInvoiceStatusMap?.pending?.length);

  const showBulkInvoiceProgress = showProgress?.progress || showProgress?.fail;

  const { useKafkaBulkFlow,mergeManageOrderInvoice } = ConfigDictionary;

 // Add keyboard shortcut for Ctrl + P to trigger printBulkInvoices
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault(); // Prevent browser's default print dialog

        if (document.querySelector('[role="dialog"]')) {
          console.log("Ignoring shortcut due to open dialog");
          return;
        }

        if (invoiceNumbers.length === 0) {
          console.log("Ignoring shortcut: no invoices available");
          return;
        }

        if (printInvoicesLoading) {
          console.log("Ignoring shortcut: print operation in progress");
          return;
        }

        console.log("Executing printBulkInvoices for Ctrl + P");
        logLoadTrace(printBulkInvoices, "bulk_invoice_print_invoices_time");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [invoiceNumbers, printInvoicesLoading]);
  
  useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    // Check for Ctrl+A or Command+A
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
      event.preventDefault(); // Prevent default browser behavior (e.g., select all)
      // Only trigger if there are selected orders, no modal is open, and no bulk invoicing is in progress
      if (
        !document.querySelector('[role="dialog"]') &&
        !bulkInvoceInProgress
      ) {
        console.log("Executing handleClickBulk for Ctrl+A");
        logLoadTrace(
          () => (useKafkaBulkFlow && checkedOrderNumbers.length > 5)
            ? handleBulkInvoicingNewApproach()
            : handleBulkInvoicing(),
          "bulk_invoice_handle_click_bulk_time"
        );
      } else {
        console.log("Ignoring Ctrl+A: ", {
          hasSelectedOrders: checkedOrderNumbers.length > 0,
          isModalOpen: !!document.querySelector('[role="dialog"]'),
          isBulkInvoicingInProgress: bulkInvoceInProgress,
        });
      }
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [checkedOrderNumbers, bulkInvoceInProgress, useKafkaBulkFlow]);

  const navigate = useNavigate();
  const handleRedirectUrl = (url:string, rowData: any) => {
    
    let targetPath: string;
  
    if (ConfigDictionary?.mergeManageOrderInvoice && rowData?.invoiceNumber) {
      targetPath = `/dashboard/sale/manageInvoices/viewInvoice/${rowData.orderNumber}`;
    } else {
      targetPath = `/dashboard/sale/manageOrders/viewOrder/${rowData.orderId}`;
    }
    navigate(targetPath, { state: rowData });

  }
  
  const handleFilterSearchValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterSearchValue(e.target.value);
    logEvent(analytics, "bulk_invoice_filter_applied", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "filter_type": e.target.value,
    });
    e.stopPropagation();
  };

  const handleFilterTypeChange = (type: string) => {
    setSelectedFilterType(type);
    setFilterSearchValue("");
  };
   
  const handleSelectedFilterChange = (key: string, value: string) => {
    setSelectedFilters((prev) => {
      const current = prev[key] || [];
      const newFilters = {
        ...prev,
        [key]: current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value],
      };
      return newFilters;
    });
  };
  
  useEffect(() => {
    const counts: Record<string, Record<string, number>> = {};
    filterKeys.forEach((key) => {
      counts[key] = {};
    });

    if (filterKeys.includes("status")) {
      const labelToIdMap = new Map<string, string>();
      let allDmsLabel: string | undefined;
      orderTrackingStagesList.forEach((stage) => {
        if (stage?.dmsLabel && stage?.id) {
          labelToIdMap.set(stage.dmsLabel.toUpperCase(), stage.id);
          if (stage.id === "ALL") {
            allDmsLabel = stage.dmsLabel.toUpperCase();
          }
        }
      });

      orderTrackingStagesList.forEach((stage: any) => {
        if (stage?.dmsLabel && stage.dmsLabel.toUpperCase() !== allDmsLabel) {
          counts["status"][stage.dmsLabel.toUpperCase()] = 0;
        }
      });

      data.forEach((row: any) => {
        const rowStatus = row?.status?.toUpperCase();
        Object.keys(counts["status"]).forEach((key) => {
          const labels = labelToIdMap.get(key)?.split(',').map((label) => label.trim()) ?? [];
          if (labels.includes(rowStatus)) {
            counts["status"][key] += 1;
          }
        });
      });
    }

    filterKeys.filter((key) => key !== "status").forEach((key) => {
      data.forEach((row: any) => {
        const value = row[key];
        if ( typeof value === "string" && value) {
          counts[key][value.toLowerCase()] = (counts[key][value.toLowerCase()] || 0) + 1;
        }
      });
    });

    setMultipleFiltersList(counts);
  }, [orderTrackingStagesList, data, filterKeys]);

  useEffect(() => {
    localStorage.setItem('multipleFiltersListBulkInvoice', JSON.stringify(selectedFilters));
    
    // Check if filters were cleared and refresh data if needed
    const hasAnyFilters = Object.values(selectedFilters).some(arr => arr.length > 0);
    
    if (!hasAnyFilters && statusFilter !== "ALL") {
      setStatusFilter("ALL");
    }
  }, [selectedFilters, statusFilter]);

  useEffect(() => {
    setRows(filteredData);
  }, [filteredData]);

  return (
    <div className="bulk_invoice_parent">
      <ScreenOverlay apply={loader} />
      <CustomBulkModal
        type={genericModalProps?.type}
        message={genericModalProps?.message}
        leftButtonText={genericModalProps?.leftButtonText}
        rightButtonText={genericModalProps?.rightButtonText}
        modalOpen={genericModalProps?.open}
        onLeftButtonClick={genericModalProps?.onLeftButtonClick}
        onRightButtonClick={genericModalProps?.onRightButtonClick}
        onClose={resetGenericModalProps}
        confirmedOrders={skuReplacementConfigValue ? summaryInvoicableCount:  (invoicableOrders.length ?? 0)}
        partiallyConfirmedOrders={skuReplacementConfigValue ? summaryPartiallyInvoicableCount : (partiallyInvoicableOrders.length ?? 0)}
        unavailableOrders={skuReplacementConfigValue ?summaryUnavailableCount :   (unavailableOrders.length ?? 0)}
        showSummary={checkedOrderNumbers.length > 0}
        filterConfirmedOrders={() => filterOrders(invoicableOrders)}
        filterPartiallyConfirmedOrders={() => filterOrders(partiallyInvoicableOrders)}
        filterUnavailableOrders={() => filterOrders(unavailableOrders)}
        insideBulkInvoice={true}
      />

      {showBulkInvoiceProgress && (
        <BulkProgress
          type={bulkType}
          bulkStatusMap={orderBulkStatusMap}
          showProgress={showProgress}
          handleHideProgress={handleHideProgress}
        />
      )}

      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your report will be downloaded shortly.
        </Alert>
      </Snackbar>

      { mergeManageOrderInvoice ? 
        <div className="bulk-invoice-form-header">
          <FormHeader
            parentLabel={ "Manage Orders" }
            label={"Bulk Invoice"}
            goBackToParent={() => {
                navigate(-1);
              }
            }
          />
          <div style={{ display: 'flex', alignItems: 'center', position: 'relative', width: '20%' }}>
            <Search searchFunction={handleSearchValueChange} />
          </div>
        </div>
        : 
        <Header
          title={"Bulk Invoice"}
          searchFunction={handleSearchValueChange}
          onRefresh={init}
          resetSearch={resetSearch}
        />
      }
      <div className="dms_toolbar">
        <div className="bulk_invoice_support_utility_dates">
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            className="manage_order_dateEnter"
          >
            <DatePicker
              label="From Date"
              inputFormat="DD-MM-YYYY"
              value={startDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setStartDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} inputProps={{
                  ...props.inputProps,
                  readOnly: true,
                }} disabled size="small" />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              inputFormat="DD-MM-YYYY"
              value={endDate}
              maxDate={dayjs()}
              onChange={(value) => {
                if (value) {
                  setEndDate(value);
                }
              }}
              renderInput={(props) => (
                <TextField {...props} inputProps={{
                  ...props.inputProps,
                  readOnly: true,
                }} disabled size="small" />
              )}
            />
          </LocalizationProvider>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#237C9D",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
            onClick={handleApplyLog}
          >
            Apply
          </Button>
          <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              backgroundColor: "#f0fbff",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "none",
              },
            }}
            onClick={handleClearAllLog}
          >
            Reset
          </Button>
        </div>
        {multipleCategoryFilterEnabled && (
          <FormControl className="manage_secondary_orders_filter">
            <span style={{ fontSize: "14px", color: "#6E6969" }}>Filter:</span>
            <Select
              variant="outlined"
              labelId="dropdown_label"
              open={multipleFiltersVisible}
              value="Filter Orders"
              onOpen={() => {
                setMultipleFiltersVisible(true);
                setFilterSearchValue("");
              }}
              onClose={() => setMultipleFiltersVisible(false)}
              renderValue={() => (
                <span style={{ color: "#909090", fontSize: "14px" }}>
                  Filter Orders
                </span>
              )}
              sx={{
                border: Object.values(selectedFilters)?.some(arr => arr?.length > 0)
                  ? "1px solid var(--dashboard-theme-color)"
                  : "1px solid #ccc",
                boxSizing: "border-box",
                height: "37px",
                minWidth: "190px",
                marginLeft: "10px",
                "& .MuiSelect-select": {
                  height: "32px",
                  padding: "6px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#909090",
                  outline: "none",
                  border: "none",
                },
                "& .MuiOutlinedInput-root.Mui-focused": {
                  outline: "none",
                  boxShadow: "none",
                },

                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#DEDEDE",
                  borderWidth: "1px",
                },

                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#DEDEDE",
                },

                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#DEDEDE",
                  borderWidth: "1px",
                },
              }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "right",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
                PaperProps: {
                  sx: {
                    boxShadow: "none",
                    marginTop: "4px",
                    border: "1px solid #DEDEDE",
                  },
                },
                MenuListProps: {
                  sx: {
                    paddingTop: "8px",
                    paddingBottom: "0",
                  },
                },
              }}
            >
              <MenuItem
                key={`filter-${selectedFilterType}-${JSON.stringify(selectedFilters)}`}
                disableRipple
                style={{
                  padding: 0,
                  backgroundColor: "transparent",
                  outline: "none",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div className="MSO_filter-dropdown-container"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="MSO_filter-header">
                    <span className="MSO_filter-name">All Filters</span>
                    <span
                      className={`MSO_filter-clear-all ${
                        (Object.values(selectedFilters).some((arr) => arr.length > 0) || 
                          filterSearchValue) &&
                        `MSO_filter-clear-all_active`
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedFilters({});
                        setFilterSearchValue("");
                      }}
                    >
                      Clear All
                    </span>
                  </div>
                  <div className="MSO_filter_searchBar_container">
                    <div></div>
                    <input
                      className="MSO_fiter_searchBar"
                      placeholder="Search..."
                      value={filterSearchValue}
                      onClick={(e) => e.stopPropagation()}
                      onChange={handleFilterSearchValueChange}
                      autoFocus
                      onBlur={(e) => e.target.focus()}
                    />
                  </div>

                  <div className="MSO_filter-options">
                    <div className="MSO_filter-options-left">
                      {filterKeys.map((key) => (
                        <div
                          key={key}
                          className={`${selectedFilterType === key && `MSO_filterSelected`}`}
                          onClick={(e) => {
                            handleFilterTypeChange(key);
                            e.stopPropagation();
                          }}
                        >
                          {key === "salesRepName"
                            ? "SalesRep"
                            : key === "routeIdAndName"
                            ? "Route"
                            : key === "gstNo"
                            ? "GST Type"
                            : capitalizeFirstLetter(key)} ({(selectedFilters[key] || []).length})
                        </div>
                      ))}
                    </div>
                    <div className="MSO_filter-options-right">
                      {filterKeys.map(
                        (key) =>
                          selectedFilterType === key && (
                            <div className="MSO_filter-option" key={key}>
                              {Object.keys(multipleFiltersList[key] ?? {})
                                .filter((value) =>
                                  filterSearchValue && typeof value === "string"
                                    ? value.toLowerCase().includes(filterSearchValue.toLowerCase())
                                    : true
                                )
                                .map((value) => (
                                  <label
                                    key={value}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      color: "#444444",
                                      fontSize: "13px",
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={(selectedFilters[key] || []).includes(value)}
                                      onChange={() => handleSelectedFilterChange(key, value)}
                                      style={{ borderColor: "#CBCBCB" }}
                                    />
                                     {`${
                                      key === "source"
                                        ? value.toUpperCase()
                                        : (key === "salesRepName" || key === "routeIdAndName")
                                         ? `${capitalizeFirstLetter(truncateString(value,20))}`
                                        : key === "gstNo"
                                         ? (value.toLowerCase().includes("non")
                                             ? "Non-GST Outlet"
                                             : "GST Outlet")
                                       : capitalizeFirstLetter(value)
                                      } (${multipleFiltersList[key]?.[value] || 0})`}
                                  </label>
                                ))}
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </MenuItem>
            </Select>
          </FormControl>
        )}
   
      </div>

      {loader ? (
        <Loader sx={{ position: "absolute", top: "55%" }} />
      ) : (
        <CustomDataGrid
          key={"bulkInvoice"}
          rows={Array.isArray(rows) ? rows : []}
          columnsMetaData={bulkInvoiceColumnsMetaData()}
          orderStatusConfig={orderTrackingStagesList}
          redirectUrl="/sale/manageOrders/viewOrder/"
          redirectUrlFunction={handleRedirectUrl}
          tableWidth={0.723}
          downloadSingleReportConfig={downloadSingleReportConfig}
          isCheckboxSelection={true}
          setCheckedIdArray={handleSetCheckedIdArray}
          handleClickBulk={handleBulkInvoiceClick}
          bulkType={ bulkType }
          footerButtonLoading={bulkInvoiceButtonLoading || bulkInvoceInProgress}
          checkedIdArray={checkedOrderNumbers}
          disabledRowIds={bulkInvoiceStatusMap?.pending || []}
          rowIdsWithCheckboxHidden={nonSelectableOrderNumbers}
          printBulkInvoices={() => logLoadTrace(printBulkInvoices, 'bulk_invoice_print_invoices_time')}
          printInvoicesLoading={printInvoicesLoading}
          orderSourceConfig={orderSourcesRef.current}
        />
      )}
    </div>
  );
};

export default BulkInvoice;
